import config from 'src/config/config';
import api from 'src/api/interceptor';

export function getStageDataApi(
  stationId,
  tenantOrganisationId,
  selectedDirection,
  selectedPlant,
) {
  const params = new URLSearchParams({
    stage_id: stationId,
    tenant_organisation_id: tenantOrganisationId,
  });

  const selectedDirections = Array.isArray(selectedDirection)
    ? selectedDirection
    : [selectedDirection];

  selectedDirections.forEach((direction) => {
    if (direction) {
      params.append('direction', direction);
    }
  });

  const selectedPlants = Array.isArray(selectedPlant)
    ? selectedPlant
    : [selectedPlant];

  selectedPlants.forEach((plantId) => {
    if (plantId) {
      params.append('plant_id', plantId);
    }
  });

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/stage-dashboard/?${params.toString()}`,
    )
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
}

export function getTargetVsActualForConfigApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
  configId,
  weightBridgeEventUUID,
) {
  const params = new URLSearchParams({
    tenant_organisation_id: tenantOrganisationId,
    vehicle_tracking_number: vehicleTrackingNumber,
    config_id: configId,
  });

  if (weightBridgeEventUUID !== undefined && weightBridgeEventUUID !== null) {
    params.append('weight_bridge_event_uuid', weightBridgeEventUUID);
  }

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-target-vs-actual/?${params.toString()}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getTimelineApi(vehicleTrackingNumber, tenantOrganisationId) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-timeline/?vehicle_tracking_number=${vehicleTrackingNumber}&tenant_organisation_id=${tenantOrganisationId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getWorkflowStagesDataForUpcomingStageRequestApi(
  vehicleTrackingNumber,
  tenantOrganisationId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-workflow-stages-data-for-upcoming-workflow-stage-request/?vehicle_tracking_number=${vehicleTrackingNumber}&tenant_organisation_id=${tenantOrganisationId}`,
    )
    .then((res) => Promise.resolve(res));
}
export function getUpcomingWorkflowStageRequestApi(
  vehicleTrackingNumber,
  tenantOrganisationId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-upcoming-workflow-stage-request/?vehicle_tracking_number=${vehicleTrackingNumber}&tenant_organisation_id=${tenantOrganisationId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function createUpcomingWorkflowStageRequestApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/create-upcoming-workflow-stage-request/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getVehicleTrackingDetailApi(
  vehicleTrackingNumber,
  tenantOrganisationId,
  workflowStageId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-tracking-details/?vehicle_tracking_number=${vehicleTrackingNumber}&tenant_organisation_id=${tenantOrganisationId}&workflow_stage_id=${workflowStageId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getPurchaseOrderListApi(
  vehicleTrackingNumber,
  tenantOrganisationId,
  workflowStageId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-purchase-orders-for-vehicle-tracking/?vehicle_tracking_number=${vehicleTrackingNumber}&tenant_organisation_id=${tenantOrganisationId}&workflow_stage_id=${workflowStageId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getPoItemsApi(
  vehicleTrackingNumber,
  poIds,
  tenantOrganisationId,
  workflowStageId,
) {
  const poId = Array.isArray(poIds)
    ? poIds.map((id) => `po_ids=${id}`).join('&')
    : '';
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-po-item-for-vehicle-tracking/?tenant_organisation_id=${tenantOrganisationId}&vehicle_tracking_number=${vehicleTrackingNumber}&${poId}&workflow_stage_id=${workflowStageId}`,
    )
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
}

export function skipStageApi(data, tenantOrganisationId) {
  return api
    .get(`${config.test_url}api/vehicle-tracking/skip-stage/`, {
      params: {
        vehicle_tracking_number: data?.vehicleTrackingNumber,
        workflow_stage_id: data?.workflowStageId,
        tenant_organisation: tenantOrganisationId,
      },
    })
    .then((res) => Promise.resolve(res));
}

export function moveToNextStageApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/move-vehicle-to-next-stage/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getBusinessPartnersWithOpenPoDropdownOptionsApi(
  tenantOrganisationId,
  businessPartnerSearchTerm,
  categoryKeyId,
) {
  const params = {
    tenant_organisation_id: tenantOrganisationId,
    search_term: businessPartnerSearchTerm,
    category_key_id: categoryKeyId,
  };
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-business-partners-with-open-po-dropdown-options/`,
      {
        params,
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getPurchaseOrderApi(searchData) {
  return api
    .get(
      `${config.test_url}api/procurement/get-purchase-orders/?business_partner_unique_number=${searchData?.business_partner_unique_number}&tenant_organisation_id=${searchData?.tenant_organisation_id}${
        searchData?.poID ? `&po_number_filter=${searchData?.poID}` : ''
      }`,
    )
    .then((res) => Promise.resolve(res));
}

export function getPurchaseOrdersAndLineItemDataApi(searchData) {
  return api
    .get(
      `${config.test_url}api/procurement/get-purchase-orders-and-line-item-data/?business_partner_unique_number=${searchData?.business_partner_unique_number}&tenant_organisation_id=${searchData?.tenant_organisation_id}${
        searchData?.poID ? `&po_number_filter=${searchData?.poID}` : ''
      }&page_number=${searchData?.page_number}`,
    )
    .then((res) => Promise.resolve(res));
}

export function createVehicleTrackingApi(data) {
  return api
    .post(`${config.test_url}api/vehicle-tracking/create/`, data)
    .then((res) => Promise.resolve(res));
}

export function getBarcodeApi(organisationId, vehicleTrackingNumber) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-barcode/?tenant_organisation_id=${organisationId}&vehicle_tracking_number=${vehicleTrackingNumber}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getVehicleTrackingReportDataApi(
  vehicleTrackingNumber,
  tenantOrganisationId,
) {
  return api
    .get(`${config.test_url}api/vehicle-tracking/get-report-data/`, {
      params: {
        vehicle_tracking_number: vehicleTrackingNumber,
        tenant_organisation_id: tenantOrganisationId,
      },
    })
    .then((res) => Promise.resolve(res));
}

export function getAssignedStagesApi(profileId, directions) {
  const params = new URLSearchParams({
    profile_id: profileId,
  });
  directions.forEach((directionValue) => {
    if (directionValue) {
      params.append('direction', directionValue);
    }
  });

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-stages-assigned-for-profile/?${params.toString()}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getVehicleTrackingWorkflowsApi(
  tenantOrganisationId,
  direction,
) {
  const params = {
    tenant_organisation_id: tenantOrganisationId,
  };
  if (direction) {
    params.direction = direction;
  }
  return api
    .get(`${config.test_url}api/vehicle-tracking/get-workflows/`, {
      params,
    })
    .then((res) => Promise.resolve(res));
}

export function getWorkflowStagesForVehicleTrackingApi(stageId, inputData) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-workflow-stages-for-vehicle-tracking/?stage_id=${stageId}&input_data=${inputData}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getTargetVsActualConfigForWorkflowStageApi(
  workflowStageId,
  vehicleTrackingNumber,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-target-vs-actual-config-for-workflow-stage/?workflow_stage_id=${workflowStageId}&vehicle_tracking_number=${vehicleTrackingNumber}`,
    )
    .then((res) => Promise.resolve(res));
}

export function createTargetVsActualLogsApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/create-target-vs-actual-logs/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getVehicleTrackingReportListApi(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  paginationBatchSize,
  queryString,
) {
  const searchFieldFilterList = new URLSearchParams(queryString).toString();
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-tracking-list/?${searchFieldFilterList}`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          page_number: pageNumber,
          search_term: searchInput,
          pagination_batch_size: paginationBatchSize,
          // hardcoded to inward to maintain current flow
          direction: '1',
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getVehicleTrackingListApi(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  paginationBatchSize,
  queryString,
) {
  const params = new URLSearchParams(queryString);

  tableFieldFilter?.forEach((fieldId) => params.append('field_id', fieldId));

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-trackings/?${params.toString()}`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          page_number: pageNumber,
          search_term: searchInput || null,
          sort_order: tableSortOrder,
          sort_field: tableSortField,
          pagination_batch_size: paginationBatchSize,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getNextAvailableWorkflowStagesApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-next-available-workflow-stages/?`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          vehicle_tracking_number: vehicleTrackingNumber,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function skipAndMoveVtToAnotherWsApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
  requestedWorkflowStageId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/skip-and-move-vt-to-another-ws/?`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          vehicle_tracking_number: vehicleTrackingNumber,
          requested_workflow_stage_id: requestedWorkflowStageId,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getVarianceReportDataV2Api(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  paginationBatchSize,
  workflowIdList,
  materialCodeList,
  supplierList,
  queryString,
  fieldIds,
) {
  const params = new URLSearchParams(queryString);

  workflowIdList?.forEach((id) => params.append('workflow_id', id));
  materialCodeList?.forEach((id) =>
    params.append('selected_material_code', id),
  );
  supplierList?.forEach((id) => params.append('supplier_id', id));
  fieldIds?.forEach((id) => params.append('field_id', id));

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-variance-report-data-v2/?${params.toString()}`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          page_number: pageNumber,
          search_term: searchInput || null,
          pagination_batch_size: paginationBatchSize,
          // hardcoded to inward to maintain current flow
          direction: '1',
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getAvailableMaterialsCodesForOrganisationApi(
  tenantOrganisationId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-available-material-codes/?tenant_organisation_id=${tenantOrganisationId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function captureVehicleWeightApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
  fieldType,
  tableName,
  workflowStageId,
  workCenterId,
  weightBridgeEventUUID,
  vtLoadHeaderUniqueNumber,
) {
  const params = {
    tenant_organisation_id: tenantOrganisationId,
    vehicle_tracking_number: vehicleTrackingNumber,
    field: fieldType,
    table_name: tableName,
    workflow_stage_id: workflowStageId,
    work_center_id: workCenterId,
    weight_bridge_event_uuid: weightBridgeEventUUID,
    ...(vtLoadHeaderUniqueNumber
      ? { vt_load_header_unique_number: vtLoadHeaderUniqueNumber }
      : {}),
  };

  return api.get(
    `${config.test_url}api/vehicle-tracking/send-capture-weight-event-to-sqs/`,
    { params },
  );
}

export function getCameraWeightReportApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-camera-weight-report/?tenant_organisation_id=${tenantOrganisationId}&vehicle_tracking_number=${vehicleTrackingNumber}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getCameraWeightReportForVehicleTrackingLoadApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
  vtLoadHeaderUniqueNumber,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-camera-weight-report-for-vehicle-tracking-load/`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          vehicle_tracking_number: vehicleTrackingNumber,
          vt_load_header_unique_number: vtLoadHeaderUniqueNumber,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getWeighBridgeWorkCentersApi(
  tenantOrganisationId,
  workCenterType,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-weigh-bridge-work-centers/?tenant_organisation_id=${tenantOrganisationId}&work_center_type=${workCenterType}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getInwardReportApi(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  pageData,
  queryString,
) {
  const params = new URLSearchParams(queryString);
  tableFieldFilter?.forEach((fieldId) => params.append('field_id', fieldId));
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-inward-report/?${params.toString()}`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          page_number: pageNumber,
          search_term: searchInput || null,
          sort_order: tableSortOrder,
          sort_field: tableSortField,
          page_data: pageData,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getInwardReportWithExitTimeApi(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  pageData,
  queryString,
) {
  const params = new URLSearchParams(queryString);
  tableFieldFilter?.forEach((fieldId) => params.append('field_id', fieldId));
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-inward-report-with-exit-time/?${params.toString()}`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          page_number: pageNumber,
          search_term: searchInput || null,
          sort_order: tableSortOrder,
          sort_field: tableSortField,
          page_data: pageData,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getPackTypeApi(tenantOrganisationId) {
  return api
    .get(
      `${config.test_url}api/material/get-pack-types/?tenant_organisation_id=${tenantOrganisationId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function createVehicleTrackingLineItemApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/create-vehicle-tracking-line-items/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function updateVehicleTrackingLineItemApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/update-vehicle-tracking-line-items/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function updateFieldForVehicleTrackingApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/update-field-for-vehicle-tracking/`,
      data,
    )
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
}

export function getPurchaseOrderLineItemsApi(tenantOrganisationId, poId) {
  return api
    .get(
      `${config.test_url}api/procurement/get-purchase-order-line-items/?tenant_organisation_id=${tenantOrganisationId}&purchase_order_id=${poId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getVehicleTrackingLineItemsApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-tracking-line-items/?tenant_organisation_id=${tenantOrganisationId}&vehicle_tracking_number=${vehicleTrackingNumber}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getStorageLocationsApi(tenantOrganisationId, plantIds = []) {
  let url = `${config.test_url}api/material/get-storage-locations/?tenant_organisation_id=${tenantOrganisationId}`;

  plantIds.forEach((id) => {
    url += `&plant_id=${id}`;
  });

  return api.get(url).then((res) => Promise.resolve(res));
}

export function createGrnForVehicleTrackingApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/create-grn-for-vehicle-tracking/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getVehicleTrackingAwaitingGrnApi(
  pageNumber,
  searchInput,
  tableSortFieldOrder,
  tableSortField,
  selectedFieldFilter,
  tenantOrganisationId,
  queryString,
) {
  const fieldFilter = Array.isArray(selectedFieldFilter)
    ? selectedFieldFilter.map((id) => `field_id=${id}`).join('&')
    : '';
  const searchFieldFilterList = new URLSearchParams(queryString).toString();
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-trackings-awaiting-grn/?${fieldFilter}&${searchFieldFilterList}`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          page_number: pageNumber,
          search_query: searchInput,
          sort_order: tableSortField,
          sort_field: tableSortFieldOrder,
          // hardcoded to inward to maintain current flow
          direction: '1',
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getGrnDetailsForVehicleTrackingApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-grn-details-for-vehicle-tracking/?tenant_organisation_id=${tenantOrganisationId}&vehicle_tracking_number=${vehicleTrackingNumber}`,
    )
    .then((res) => Promise.resolve(res));
}

export function updateGrnDetailsForVehicleTrackingApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/update-grn-details-for-vehicle-tracking/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getPlantsApi(tenantOrganisationId) {
  return api
    .get(
      `${config.test_url}api/oms/get-plants/?tenant_organisation_id=${tenantOrganisationId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getPackTypeForPurchaseOrderLineItemApi(
  tenantOrganisationId,
  purchaseOrderLineItemId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-pack-type-for-purchase-order-line-item/?tenant_organisation_id=${tenantOrganisationId}&purchase_order_line_item_id=${purchaseOrderLineItemId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getTargetVsActualLogsApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
  workflowStageId,
) {
  const params = {
    tenant_organisation_id: tenantOrganisationId,
    vehicle_tracking_number: vehicleTrackingNumber,
    workflow_stage_id: workflowStageId,
  };

  return api
    .get(`${config.test_url}api/vehicle-tracking/get-target-vs-actual-logs/`, {
      params,
    })
    .then((res) => Promise.resolve(res));
}

export function getTareWeightHistoryForVehicleNumberApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  const params = {
    tenant_organisation_id: tenantOrganisationId,
    vehicle_tracking_number: vehicleTrackingNumber,
  };

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-tare-weight-history-for-vehicle-number/`,
      { params },
    )
    .then((res) => Promise.resolve(res));
}

export function getWorkflowStagesForWorkflowApi(
  tenantOrganisationId,
  workflowId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-workflow-stages-for-workflow/?tenant_organisation_id=${tenantOrganisationId}&workflow_id=${workflowId}`,
    )
    .then((res) => Promise.resolve(res));
}
export function getWorkflowStagesForCurrentUserApi(
  tenantOrganisationId,
  workflowId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-workflow-stages-for-current-user/?tenant_organisation_id=${tenantOrganisationId}&workflow_id=${workflowId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getBusinessPartnersDropdownOptionsApi(
  tenantOrganisationId,
  searchTerm,
) {
  return api
    .get(
      `${config.test_url}api/core/get-business-partners/?tenant_organisation_id=${tenantOrganisationId}&search_term=${searchTerm}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getUnitOfMeasurementsApi(tenantOrganisationId, searchTerm) {
  return api
    .get(
      `${config.test_url}api/material/get-unit-of-measurements/?tenant_organisation_id=${tenantOrganisationId}&search_term=${searchTerm}`,
    )
    .then((res) => Promise.resolve(res));
}

export function createDimensionApi(data) {
  return api
    .post(`${config.test_url}api/material/create-dimension/`, data)
    .then((res) => Promise.resolve(res));
}

export function getDimensionListApi(tenantOrganisationId, searchTerm) {
  return api
    .get(
      `${config.test_url}api/material/get-dimension-list/?tenant_organisation_id=${tenantOrganisationId}&search_term=${searchTerm}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getQualityCheckListApi(tenantOrganisationId, searchTerm) {
  return api
    .get(
      `${config.test_url}api/material/get-quality-check-list/?tenant_organisation_id=${tenantOrganisationId}&search_term=${searchTerm}`,
    )
    .then((res) => Promise.resolve(res));
}

export function createQualityCheckProductAndDimensionApi(data) {
  return api
    .post(
      `${config.test_url}api/material/create-quality-check-products-and-dimensions/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}
export function updateQualityCheckProductAndDimensionApi(data) {
  return api
    .post(
      `${config.test_url}api/material/update-quality-check-products-and-dimensions/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getQualityCheckProductAndDimensionDetailApi(
  tenantOrganisationId,
  qualityCheckUniqueNumber,
) {
  return api
    .get(
      `${config.test_url}api/material/get-quality-check-product-and-dimension-details/?tenant_organisation_id=${tenantOrganisationId}&quality_check_unique_number=${qualityCheckUniqueNumber}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getAvailableQualityChecksForVehicleTrackingApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-available-quality-checks-for-vehicle-tracking/?tenant_organisation_id=${tenantOrganisationId}&vehicle_tracking_number=${vehicleTrackingNumber}`,
    )
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
}

export function createVehicleTrackingLineItemRejectionLogApi(
  tenantOrganisationId,
  vehicleTrackingLineItemId,
  quantity,
) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/create-vehicle-tracking-line-item-rejection-log/`,
      {
        tenant_organisation_id: tenantOrganisationId,
        vehicle_tracking_line_item_id: vehicleTrackingLineItemId,
        quantity,
      },
    )
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
}

export function getVehicleTrackingLineItemRejectionLogsApi(
  vehicleTrackingNumber,
  tenantOrganisationId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-tracking-line-item-rejection-logs/`,
      {
        params: {
          vehicle_tracking_number: vehicleTrackingNumber,
          tenant_organisation_id: tenantOrganisationId,
        },
      },
    )
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
}

export function getVehicleTrackingLineItemQualityCheckLogApi(
  tenantOrganisationId,
  qualityCheckId,
  vehicleTrackingNumber,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-tracking-line-items-for-quality-check-log/?tenant_organisation_id=${tenantOrganisationId}&quality_check_id=${qualityCheckId}&vehicle_tracking_number=${vehicleTrackingNumber}`,
    )
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
}
export function getDimensionForQualityCheckCreateLogApi(
  tenantOrganisationId,
  qualityCheckId,
  vehicleTrackingNumber,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-dimensions-for-quality-check-create-log/?tenant_organisation_id=${tenantOrganisationId}&quality_check_id=${qualityCheckId}&vehicle_tracking_number=${vehicleTrackingNumber}`,
    )
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
}

export function createVehicleTrackingLineItemQualityCheckLogApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/create-vehicle-tracking-line-item-quality-check-log/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getLogForQualityCheckApi(tenantOrganisationId, qualityCheckId) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-log-for-quality-check/?tenant_organisation_id=${tenantOrganisationId}&quality_check_log_id=${qualityCheckId}`,
    )
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
}

export function getVahan01DetailsApi(tenantOrganisationId, vehicleNumber) {
  return api.get(
    `${config.test_url}api/vehicle-tracking/get-vahan-01-details/`,
    {
      params: {
        tenant_organisation_id: tenantOrganisationId,
        vehicle_number: vehicleNumber,
      },
    },
  );
}

export function getVehicleTrackingDashboardDataApi(
  tenantOrganisationId,
  startDate,
  endDate,
  selectedWorkflowId,
  selectedWorkflowStageId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-tracking-dashboard-data/`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          start_date: startDate,
          end_date: endDate,
          workflow_id: selectedWorkflowId,
          workflow_stage_id: selectedWorkflowStageId,
        },
      },
    )
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
}

export function getTenantPermissionsApi(tenantId) {
  return api.get(`${config.test_url}api/tenant/get-tenant-permissions/`, {
    params: {
      tenant_id: tenantId,
    },
  });
}

export function getVehicleTrackingChangeLogListApi(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  paginationBatchSize,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  queryString,
) {
  const tableFieldFilterList = tableFieldFilter
    ?.map((id) => `field_id=${id}`)
    .join('&');
  const searchFieldFilterList = new URLSearchParams(queryString).toString();

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-tracking-change-log-list/?${tableFieldFilterList}&${searchFieldFilterList}`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          page_number: pageNumber,
          search_term: searchInput,
          pagination_batch_size: paginationBatchSize,
          sort_order: tableSortOrder,
          sort_field: tableSortField,
          // hardcoded to inward to maintain current flow
          direction: '1',
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getVehicleTrackingChangeLogsApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-tracking-change-logs/?tenant_organisation_id=${tenantOrganisationId}&vehicle_tracking_number=${vehicleTrackingNumber}`,
    )
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
}

// Invoice API functions
export function createVehicleTrackingAttachmentApi(formData) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/create-vehicle-tracking-attachments/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
}

export function getVehicleTrackingAttachmentsApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
  fileType = null,
) {
  const params = new URLSearchParams({
    tenant_organisation_id: tenantOrganisationId,
    vehicle_tracking_number: vehicleTrackingNumber,
  });

  if (fileType) {
    params.append('file_type', fileType);
  }

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-tracking-attachments/?${params.toString()}`,
    )
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
}

export function getPrefillSuggestionsForVehicleTrackingLineItemsApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  const params = new URLSearchParams({
    tenant_organisation_id: tenantOrganisationId,
    vehicle_tracking_number: vehicleTrackingNumber,
  });

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-prefill-suggestions-for-vehicle-tracking-line-items/?${params.toString()}`,
    )
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
}

export function deleteVehicleTrackingAttachmentApi(
  tenantOrganisationId,
  attachmentId,
) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/delete-vehicle-tracking-attachments/`,
      {
        tenant_organisation_id: tenantOrganisationId,
        attachment_id: attachmentId,
      },
    )
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
}

export function getAvailableStagesForWorkflowAssignedToUserApi(
  tenantOrganisationId,
  workflowId,
  direction,
) {
  const params = new URLSearchParams();
  params.append('tenant_organisation_id', tenantOrganisationId);

  if (workflowId) {
    const workflowIds = Array.isArray(workflowId) ? workflowId : [workflowId];

    workflowIds.forEach((item) => {
      params.append('workflow_id', item);
    });
  }

  if (direction) {
    const directions = Array.isArray(direction) ? direction : [direction];

    directions.forEach((item) => {
      params.append('directions', item);
    });
  }

  return api.get(
    `${config.test_url}api/vehicle-tracking/get-available-stages-for-workflow-assigned-to-user/?${params.toString()}`,
  );
}

export function getAssignedPlantForEmployeeApi(
  tenantOrganisationId,
  searchTerm,
) {
  const params = {
    tenant_organisation_id: tenantOrganisationId,
    search_term: searchTerm,
  };

  return api
    .get(`${config.test_url}api/sales/get-assigned-plant-for-employee/`, {
      params,
    })
    .then((res) => Promise.resolve(res));
}

export function getOutwardReportApi(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  paginationBatchSize,
  queryString,
) {
  const params = new URLSearchParams(queryString);

  tableFieldFilter?.forEach((fieldId) => params.append('field_id', fieldId));

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-outward-report/?${params.toString()}`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          page_number: pageNumber,
          sort_order: tableSortOrder,
          sort_field: tableSortField,
          pagination_batch_size: paginationBatchSize,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getVehicleTrackingCommentsApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-tracking-comments/?tenant_organisation_id=${tenantOrganisationId}&vehicle_tracking_number=${vehicleTrackingNumber}`,
    )
    .then((res) => Promise.resolve(res));
}

export function createCommentForVehicleTrackingApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/create-comment-for-vehicle-tracking/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function uploadVehicleTrackingAttachmentsApi(fileData) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/upload-vehicle-tracking-attachments/`,
      fileData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getDocumentListForVehicleTrackingApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
  searchTerm,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-document-list-for-vehicle-tracking/`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          vehicle_tracking_number: vehicleTrackingNumber,
          search_term: searchTerm,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}
